import React from 'react';
import { Button, makeStyles, Menu, MenuItem } from '@material-ui/core';
import { Trans } from 'react-i18next';

import NavbarButton from './components/NavbarButton';
import { LangButton } from './header-components/LangButton';
import { Text } from '../../shared/components/Text';

const useStyle = makeStyles(theme => ({
  button: {
    marginRight: 40,
    borderRadius: 0,
    padding: '10px 20px',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
    [theme.breakpoints.down('md')]: {
      marginRight: 20,
    },
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
    },
  },
  buttonTextColor: {
    color: theme.palette.darkGrey,
  },
  link: {
    textDecoration: 'none',
  },
}));

export const Navbar = () => {
  const classes = useStyle();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <NavbarButton to="who" label="Chi siamo" />
      <NavbarButton to="servizi" label="Servizi" />
      <NavbarButton to="formazione" label="Formazione" />
      <NavbarButton to="persone" label="Persone" />
      <NavbarButton to="contacts" label="Contatti" />

      <Button
        color="primary"
        variant="contained"
        className={classes.button}
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <Text variant="h5" className={classes.buttonTextColor}>
          <Trans>Riservato</Trans>
        </Text>
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClose}>
          <a
            href="https://hr.bgsp.it/HRBGServizi/jsp/login.jsp"
            className={classes.link}
            target="_blank"
            rel="noreferrer"
          >
            HR BGSP
          </a>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <a
            href="https://hr.informatica-online.com/Login.aspx?formatointestazione=SBG093"
            className={classes.link}
            target="_blank"
            rel="noreferrer"
          >
            ISC
          </a>
        </MenuItem>
      </Menu>

      <LangButton />
    </>
  );
};
